import { isProd } from 'helpers/utils';

export const firebaseConfig = {
    apiKey: import.meta.env.FIREBASE_API_KEY,
    authDomain: import.meta.env.FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.FIREBASE_APP_ID,
    measurementId: import.meta.env.FIREBASE_MEASUREMENT_ID,
};

export const MAX_RETRIES = 2;

export const MAX_FETCH_INTERVAL_DEV_ENV = 60_000;

export const remoteConfigSettings = {
    minimumFetchIntervalMillis: isProd() ? 43_200_000 : MAX_FETCH_INTERVAL_DEV_ENV, // fetch(cache) interval in milliseconds: 1min for non-prod, 12 hours for prod
    fetchTimeoutMillis: 15_000, // timeout in milliseconds
};

export const FIREBASE_TTL_KEY = 'firebaseTTL';

export const FIREBASE_DBs = ['firebase_remote_config'];
